import { render } from "./TopicGrid.vue?vue&type=template&id=f21800b4&scoped=true"
import script from "./TopicGrid.vue?vue&type=script&lang=js"
export * from "./TopicGrid.vue?vue&type=script&lang=js"

import "./TopicGrid.vue?vue&type=style&index=0&id=f21800b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21800b4"]])

export default __exports__